import { createFileRoute, lazyRouteComponent, notFound } from '@tanstack/react-router';
import { oauthService } from '@/api/services/oauth';
import { checkFeatureGateOAuth } from '@/helpers/statsig/featureGate';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/cloud-access/connected-apps')({
  // The account layout already awaited `ensureStatsigUserFeatureGateReady`.
  beforeLoad: ({ context, params: { accountId } }) => {
    if (!checkFeatureGateOAuth(context.statsigClient)) {
      throw notFound();
    }

    return { accountOAuthGrantsQuery: oauthService.listAccountOAuthGrantsQuery({ accountId }) };
  },
  // Fetching the list runs the permissions interceptor, which throws an AccessControlError
  // (handled as a not-found) when the user lacks `read:oauth_grants`.
  loader: ({ context: { queryClient, accountOAuthGrantsQuery } }) =>
    queryClient.ensureQueryData(accountOAuthGrantsQuery),
  component: lazyRouteComponent(
    () => import('@/components/Access/AccountOAuthGrantsList'),
    'AccountOAuthGrantsComponent',
  ),
  pendingComponent: lazyRouteComponent(
    () => import('@/components/Access/AccountOAuthGrantsList'),
    'AccountOAuthGrantsPendingComponent',
  ),
});
